import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PaidServicesService } from '../../services/paid-services.service';

@Injectable({
  providedIn: "root"
})
export class PaidActiveTimeGuard implements CanActivate {

  constructor(
    private router: Router,
    private paidServicesService: PaidServicesService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (state.url.includes('order-token')) {
      return of(true);
    }

    return this.paidServicesService.isPaidServiceActive$.pipe(
      take(1),
      map(active => active ? true : this.router.createUrlTree(['/']))
    );
  }
}
